import React, { useContext, useState, createContext } from 'react';
import localStorage from 'store';

const LangContext = createContext(null);

export const useLang = () => useContext(LangContext);

export const LangProvider = ({ children }) => {
  const initial = localStorage.get('lang') ?? 'ru';
  const [language, setLanguage] = useState(initial);

  const onSetLanguage = value => {
    if (value) {
      setLanguage(value);
      localStorage.set('lang', value);
    }
  };

  return (
    <LangContext.Provider
      value={{
        language,
        onSetLanguage,
      }}
    >
      {children}
    </LangContext.Provider>
  );
};
